import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

Vue.component('case-page', {
    data() {
        return {
            scrollTrigger: null,
        };
    },

    mounted() {
        this.scrollTrigger = new ScrollTrigger({
            trigger: '.next-project-holder',
            start: 'top bottom',
            end: 'top bottom',
            onEnter: () => {
                gsap.to('.next-project-holder__footer', {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.3,
                    ease: 'power3.easeInOut',
                });
            },
            onEnterBack: () => {
                gsap.to('.next-project-holder__footer', {
                    autoAlpha: 0,
                    y: 20,
                    duration: 0.3,
                    ease: 'power3.easeInOut',
                });
            },
        });
    },
});
